import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4672a103"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_modal_wrap edit_good" }
const _hoisted_2 = { class: "modal_place_upload_wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mpiu_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, " * "),
  /*#__PURE__*/_createTextVNode(" 商品封面 ")
], -1))
const _hoisted_4 = { class: "mpiu_tobody" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_place_input_hint" }, "上传说明：图片尺寸1：1比列，大小不能超过2M。", -1))
const _hoisted_6 = { class: "modal_place_input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 商品名称： ")
], -1))
const _hoisted_8 = { class: "modal_place_input_content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_place_input_hint" }, "标题文本不能超过十个字，超过自动省略隐藏。", -1))
const _hoisted_10 = { class: "modal_place_input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 优惠价格： ")
], -1))
const _hoisted_12 = { class: "modal_place_input_content" }
const _hoisted_13 = { class: "modal_place_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 原始价格： ")
], -1))
const _hoisted_15 = { class: "modal_place_input_content" }
const _hoisted_16 = { class: "modal_place_input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 支付通道名称 ")
], -1))
const _hoisted_18 = { class: "modal_place_input_content" }
const _hoisted_19 = { class: "modal_place_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 商品网址链接 ")
], -1))
const _hoisted_21 = { class: "modal_place_input_content" }

import { ref, unref, watch } from 'vue';
import { message, InputNumber } from 'ant-design-vue';
import { GoodItem } from '../type';
import CUpload from '@/components/CUpload.vue';

interface IProps {
  modelValue: any;
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEditGood',
  props: {
    modelValue: null
  },
  setup(__props: any) {

const props = __props as {
  modelValue: any;
};

const aInputNumber = InputNumber;

const form = ref<GoodItem>({
  title: '',
  img: '',
  link: '',
  price: '',
  origin_price: '',
  btn_name: '',
});
form.value = unref(props.modelValue);
watch(
  () => props.modelValue,
  (newVal) => {
    form.value = newVal;
  }
);

// upload module
function getBase64(img: Blob, callback: (base64Url: string) => void) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
}
const fileList = ref([]);
const loading = ref<boolean>(false);
const handleChange = (info: FileInfo): void => {
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  }
  if (info.file.status === 'done') {
    getBase64(info.file.originFileObj, (base64Url: string) => {
      if (info.file?.response?.code === 200) {
        form.value.img = info.file?.response?.data.url;
      } else {
        message.error(info.file?.response?.message);
      }
      loading.value = false;
    });
  }
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  form.value.img = '';
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CUpload, {
          "file-list": fileList.value,
          "handle-change": (info) => handleChange(info),
          loading: loading.value,
          "image-name": form.value.img,
          "click-stop": imageDel,
          class: "ant_upload"
        }, null, 8, ["file-list", "handle-change", "loading", "image-name"])
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_input, {
          value: form.value.title,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
          maxlength: 10
        }, {
          suffix: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(form.value.title.length) + "/10", 1)
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(aInputNumber), {
          min: 0,
          max: 100000,
          value: form.value.price,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.price) = $event))
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_unref(aInputNumber), {
          min: 0,
          max: 100000,
          value: form.value.origin_price,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.origin_price) = $event))
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_a_input, {
          value: form.value.btn_name,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.btn_name) = $event)),
          maxlength: "20"
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_a_input, {
          value: form.value.link,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.link) = $event))
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})